/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm } from 'utils/styles/style_helpers';



/* ++++++++++ --------------- EXPORT --------------- ++++++++++ */
// MENU > INDICATOR
// utliizes utils and CSS-IN-JS (JS objects converted to CSS using a library)
export default theme => ({
    dropDownItem: {
        display: 'flex',
        alignItems: 'center',
        padding: pxToEm(16),
        height: pxToEm(16),
        fontSize: pxToEm(14),
        fontWeight: '500',
        color: theme.color.supporting.medium.swatch,
        background: theme.color.light.light.swatch,
        cursor: 'pointer',
        transition: 'all .15s',
        '&:hover':{
            color: theme.color.primary.medium.swatch
        },
        '& .highlight':{
            fontWeight: '600',
            background: theme.color.primary.light.swatch
        }
    }
});